import styled from "styled-components";
import { Box } from "Components/Base/Layout/Box";

export const StyledCardActionsBox = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export const StyledCardContentBoxContainer = styled(Box)`
  min-width: 350px;
  flex-direction: row;
  display: flex;
`;

export const STYLE_FILTER_BUTTON = {
  color: "var(--colorTextPrimary)",
  borderColor: "transparent",
};

export const STYLE_GRID_CONTAINER = { marginBottom: "24px" };

export const STYLE_SEARCH_BOX = { flex: { xs: "1", sm: "1" } };

export const STYLE_SEARCH_FIELD = {
  maxHeight: "46px",
  flex: { xs: "1 1 auto", sm: "1 1 auto" },
  minWidth: { xs: "100%", sm: "200px" },
};

export const STYLE_SEARCH_FIELD_MOBILE = {
  maxHeight: "46px",
  flex: "1",
  minWidth: 0,
};

export const STYLE_CONTROLS_BOX = {
  flex: { xs: "1 1 auto", sm: "0 1 auto" },
  mt: { xs: 1, sm: 0 },
  minWidth: 0,
};

export const STYLE_CONTROLS_BOX_MOBILE = {
  flexShrink: 0,
  mt: 1,
};

export const STYLE_SELECT = {
  height: "46px",
  minWidth: { xs: "100%", sm: "120px" },
  flexShrink: 0,
};

export const STYLE_ICON = { mr: 1 };

export const STYLE_PAPER = {
  maxWidth: 320,
  width: "100%",
  position: "absolute",
  borderRadius: "2px !important",
  paddingTop: "0 !important",
  alignSelf: "flex-start",
  top: 90,
  right: 0,
};

export const STYLE_CHIP = {
  backgroundColor: "var(--colorWarningLight)",
  color: "var(--colorWarningDark)",
};

export const STYLE_CHIP_MOBILE = {
  backgroundColor: "var(--colorWarningLight)",
  color: "var(--colorWarningDark)",
  fontSize: "0.75rem",
  height: "24px",
};

export const STYLE_FILTER_BOX = { mt: 1, mb: 1 };
export const STYLE_DATE_FILTER = { marginBottom: 2 };
export const STYLE_SELECT_FILTER = { marginBottom: 3 };
export const STYLE_GRID_ITEM = { marginTop: 0 };
export const STYLE_DETAILS = { marginLeft: "-24px" };
export const STYLE_SEARCH_FIELD_MOBILE_INNER = {
  maxHeight: "46px",
  flex: "1",
  minWidth: 0,
};
export const STYLE_CONTROLS_BOX_MOBILE_INNER = {
  flexShrink: 0,
  mt: 1,
};
export const STYLE_FILTER_MOBILE_DETAILS = {
  width: "100%",
  padding: "8px 0",
};
export const STYLE_FILTER_MOBILE_ITEM = { marginBottom: 1 };

export const STYLE_CARD_HEADING = {
  fontWeight: "normal",
  fontSize: "inherit",
};
